import * as angular from 'angular';

class EmptyListState {}

angular.module('app.common').component('emptyListState', {
    template: require('./empty-list-state.component.html'),
    controller: EmptyListState,
    controllerAs: 'ctrl',
    bindings: {
        imageClass: '<',
        titleMessage: '<',
        message: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/empty-list-state/empty-list-state.component.ts